import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'
import Placeholder from './Placeholder'
import { connect } from 'react-redux'
import { actions as actionTrackingItem } from '../'

class ItemContainer extends Component {
  componentDidMount () {
    this.props.getTrackingStatuses()
  }
  render () {
    let placeHolder =
      !!this.props.loading ||
      !this.props.tracking ||
      !!this.props.tracking.loading

    let render = placeHolder ? <Placeholder /> : <Item {...this.props} />

    return (
      <div className='panel-scroll border-ui-3 px-1 py-2 mb-1 bg-white radius'>
        {render}
      </div>
    )
  }
}

ItemContainer.propTypes = {
  order: PropTypes.object,
  tracking: PropTypes.object,
  insertNetshoesLastEvent: PropTypes.func,
  getTrackingStatuses: PropTypes.func,
  loading: PropTypes.bool
}

const mapStateToProps = ({ ordersTracking: { tracking } }, ownProps) => {
  if (!ownProps.order || !tracking) return {}

  let orderItemTracking = tracking[ownProps.order.id] || {}
  return { tracking: orderItemTracking }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getTrackingStatuses: () => {
    if (
      !ownProps.order ||
      !ownProps.order.orderId ||
      !ownProps.order.productCode ||
      !ownProps.order.vendorId ||
      !ownProps.order.orderStatusId
    ) {
      return
    }
    dispatch(actionTrackingItem.getTrackingStatus(ownProps.order))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ItemContainer)



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/ItemContainer.js